import { type AppConfig, ENVIRONMENT } from 'types';
import { API_URL_DEV, API_URL_DEV_EMPLOYEE, buildAPI } from './api';

const IS_EMPLOYEE_WEB = process.env.REACT_APP_IS_EMPLOYEE_WEB === 'true';
const API_URL = IS_EMPLOYEE_WEB ? API_URL_DEV_EMPLOYEE : API_URL_DEV;
const API = buildAPI(API_URL);

export const DEFAULT_APP_CONFIG: AppConfig = {
	API_CONTENT_URL: API.external.contentApi,
	API_DIGITAL_SIGNATURE_URL: API.external.digitalSignature(ENVIRONMENT.TEST),
	API_URL,
	API,
	APP_ENV: ENVIRONMENT.DEVELOPMENT,
	BYPASS_ROLE_REQUIREMENT: true,
	ENABLE_RESET_VIEW: true,
	IS_ALLOWED_TO_CHANGE_LANGUAGE: true,
	IS_EMPLOYEE_WEB,
	// Localhost values come from .env.local (gitignored) — never hardcode secrets here
	CURITY_AUTHORIZATION_URL: process.env.REACT_APP_CURITY_AUTHORIZATION_URL || '',
	CURITY_CLIENT_ID: process.env.REACT_APP_CURITY_CLIENT_ID || '',
	CURITY_CLIENT_SECRET: process.env.REACT_APP_CURITY_CLIENT_SECRET || '',
	CURITY_METADATA_URL: process.env.REACT_APP_CURITY_METADATA_URL || '',
	CURITY_OAUTH_TOKEN_URL: process.env.REACT_APP_CURITY_OAUTH_TOKEN_URL || ''
};
